import React from 'react';
import {  useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const SignOutForm: React.FC = () => {
const location = useLocation()
const { pathname } = location
const { t } = useTranslation()
console.log('SignOutForm pathname:', pathname)

    return (
        <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <h1 style={{ color: '#1550F5' }}>{t('signOutPage.title')}</h1>
            <p style={{ fontSize: '18px', color: '#555' }}>{t('signOutPage.message')}</p>
            <button
            style={{
                marginTop: '20px',
                padding: '10px 20px',
                fontSize: '16px',
                color: '#fff',
                backgroundColor: '#1550F5',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer'
            }}
            onClick={() => window.location.href = '/admin'}
            >
            {t('signOutPage.login')}
            </button>
        </div>
    );
};

export default SignOutForm;
